<script>
import appConfig from "../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import "@vueform/multiselect/themes/default.css";
import Swal from "sweetalert2";
import { formatDateToWeb } from "../../helpers/date-functions";

export default {
    page: {
        title: "Bank Card",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "Bank Card",
            dtListing:[],
            loadingDetail:false,
            loadingRoles:true,
            dtKey:0,
            loadingBtn: false,
      
        };
    },

    methods: {
        getCurrency() {
            return process.env.VUE_CURRENCY || 'SGD';
        },

        formatDateToWeb,

        // add a function to fetch bank card list from VUE_APP_API_BASEURL 
        getBankCardList(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'payments/v1/2c2p/card-change/'+this.$route.params.id)
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.dtListing = response.data.data;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        // add a function to hit api and add new bank card modal
        storeBankCard(){
            this.loadingBtn = true;
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'payments/v1/2c2p/card-change/'+this.$route.params.id)
            .then(response => {
                if (response) {
                    Swal.fire({
                        title:"Email successfully send to customer!", 
                        icon:"success",
                    })
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
                Swal.fire({
                    title:"Email failed to send to customer!", 
                    icon:"error",
                })
            }).finally(() => {
                this.loadingBtn = false;
            });
        },
        
    },

    components: {
        DataTable,
    },

    mounted() {
        this.getBankCardList();
    },
    
};
require("@/assets/css/datatable.css");
</script>

<template>
   <div class="card-body mb-5">
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        <div class="col-lg-12">

                            <div class="row">
                                <!-- add new bank card button align right  -->
                                <div class="col-lg-12 text-end mb-3">
                                    <button type="button" class="btn btn-success" :disabled="loadingBtn" @click="storeBankCard">
                                        <span v-if="loadingBtn" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Add New Bank Card
                                    </button>
                                </div>
                            </div>

                            <div v-if='loadingRoles'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="table-responsive">
                                <DataTable :options="{lengthChange: false, ordering: false}" :key="dtKey" class="table table-striped table-nowrap mb-0" id="example"> 
                                     <thead class="table-secondary">
                                        <tr>
                                            <th>#.</th>
                                            <th scope="col">Token</th>
                                            <th scope="col">Masked Card</th>
                                            <th scope="col">Created At</th>
                                        </tr>
                                    </thead>

                                    <tbody>                        
                                        <tr v-for="(item, index) in dtListing" :key="index" class="content">
                                            <td>{{ index+1 }}</td>
                                            <td>{{item.token}}</td>                               
                                            <td>{{item.masked_card}}</td>
                                            <td>{{ formatDateToWeb(item.created_at, 'DD/MM/YYYY')}}</td>
                                        </tr>
                                    </tbody>
                                </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
</template>
